import { SSOLink } from '@/components/Elements/SSOLink/SSOLink';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import microsoftLogo from '@/assets/logos/MicrosoftLogo.svg';
import styles from './microsoft-sso-button.module.scss';

type MicrosoftSSOButtonProps = {
  className?: string;
  onClick: () => void;
  text?: string;
};
export const MicrosoftSSOButton = ({
  className,
  onClick,
  text,
}: MicrosoftSSOButtonProps) => {
  const { t } = useTranslation();
  return (
    <SSOLink
      className={clsx(className, styles.microsoftButton)}
      logo={<img src={microsoftLogo} alt="" />}
      text={text ?? t('login.sso.signInWithMicrosoft')}
      onClick={onClick}
      data-testid="microsoft-sso-button"
    />
  );
};
